exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ant-form-item-label, .ant-form-item {\n  font-size: 16px;\n}\n\n.form-text-mod {\n  font-size: 18px;\n  color: #001529;\n}\n\n.ant-form-item-control {\n  line-height: 14px !important;\n}\n\n.ant-input-number-input:disabled, .ant-input-disabled {\n color: #747A81 !important;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/assets/styles/style.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/assets/styles/style.css
// module chunks = 0